import React from "react";
import { Box, Typography, Button, Grid } from "@mui/material";

const FreebiesSection = () => {
  const handleWhatsAppClick = () => {
    // Replace '1234567890' with your actual WhatsApp number
    window.open("https://wa.me/+918547486582", "_blank");
  };

  return (
    <Box id="contact"
    className="component"
      sx={{
        background: "#012f57",
        color: "white",
        borderRadius: 2,
        padding: 4,
        boxShadow: 3,
        textAlign: "center",
        maxWidth: 1200, // Fixed width
        margin: "auto",
        my:{xs:1,lg:4},
        mx:{xs:4,lg:"auto"}
     
      }}
    >
      {/* Top Title */}
      <Typography
        variant="overline"
        sx={{ fontSize: "12px", color: "#ffc107", letterSpacing: 2 }}
      >
        TAKE IT FOR FREE
      </Typography>

      {/* Main Heading */}
      <Typography
        variant="h5"
        color={"white"}
        sx={{ fontWeight: "bold", marginTop: 1, marginBottom: 1 }}
      >
        Our Freebies
      </Typography>

      {/* Subtext */}
      <Typography
        variant="body2"
        sx={{ color: "#cfd8dc", marginBottom: 2, maxWidth: 600, mx: "auto" }}
      >
        All these features are included in the basic price of your assignment
        writing services.
      </Typography>

      {/* Freebie Items */}
      <Grid container spacing={2} sx={{ textAlign: "center", justifyContent: "center" }}>
        {[
          "FREE Best assignment expert assigned",
          "FREE Cover page and citations",
          "FREE Formatting in any academic style",
          "FREE Unlimited sources included",
          "FREE Unlimited Revisions for Every Order",
          "FREE Direct chat with the expert",
        ].map((item, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Typography
              variant="body1"
              sx={{ color: "#ff9800", fontWeight: "bold" }}
            >
              {item}
            </Typography>
          </Grid>
        ))}
      </Grid>

      {/* WhatsApp Now Button */}
      <Button
        onClick={handleWhatsAppClick}
        variant="contained"
        sx={{
          backgroundColor: "#4caf50",
          mt: 3,
          padding: "10px 20px",
          fontSize: "16px",
          fontWeight: "bold",
          "&:hover": { backgroundColor: "#43a047" },
        }}
      >
        WhatsApp Now
      </Button>

      {/* Footer Text */}
      <Typography variant="caption" sx={{ mt: 1, color: "#cfd8dc", display: "block" }}>
        It's fast and secure
      </Typography>
    </Box>
  );
};

export default FreebiesSection;
